import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BrandingState {
  companyName: string;
  logoUrl: string;
  brandColor: string;
  emailAddress: string;
  phone: string;
  website: string;
  reportHeader: string;
  emailFooter: string;
  loaded: boolean;
}

const initialState: BrandingState = {
  companyName: '',
  logoUrl: '',
  brandColor: '#4f46e5',
  emailAddress: '',
  phone: '',
  website: '',
  reportHeader: '',
  emailFooter: '',
  loaded: false,
};

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    setBranding: (state, action: PayloadAction<Partial<BrandingState>>) => {
      return { ...state, ...action.payload, loaded: true };
    },
    clearBranding: () => initialState,
  },
});

export const { setBranding, clearBranding } = brandingSlice.actions;
export default brandingSlice.reducer;
